import { useDispatch, useSelector } from "react-redux";
import ListTemplates from "./ListTemplates";
import { useEffect, useState } from "react";
import CardComponent from "./CardComponent";
import { setShowAddTemplateForm } from "../../../redux/templateManagement/templateManagementSlice";
import AddTemplate from "./addTemplate/AddTemplate";
import { Grid } from "@mui/material";
import SuccessMessageComponent from "../../components/SuccessMessageComponent";

function ManageTemplates() {
    const state = useSelector(state => state.templateManagementSlice);
    const [templateDetails, setTemplateDetails] = useState(null);
    const [selectedBotName, setSelectedBotName] = useState("");
    const [searchParams, setSearchParams] = useState({
        templateType: "",
        templateName: "",
        startDate: "",
        // endDate: "",
        status: "",
    });
    const [editable, setEditable] = useState(true);
    const [isSubmitForApproval, setIsSubmitForApproval] = useState(false);
    const dispatch = useDispatch();
    const handleTemplateChange = ({ templateData, val, isSubmitForApproval }) => {
        setTemplateDetails(templateData);
        setEditable(val);
        setIsSubmitForApproval(isSubmitForApproval);
        dispatch(setShowAddTemplateForm(true));
    };

    const [operationStatus, setOperationStatus] = useState({
        success: false,
        failed: false,
        message: "",
    });

    const handleCloseSuccessMessage = () => {
        setOperationStatus({ success: false, failed: false, message: "" });
    };

    const handleIsEditable = () => {
        setEditable(true);
    };
    useEffect(() => {
        dispatch(setShowAddTemplateForm(false));
        setTemplateDetails(null);
    }, []);

    return (
        <Grid>
            {state.controls.showAddTemplateForm ? (
                <AddTemplate
                    templateData={templateDetails}
                    setTemplateDetails={setTemplateDetails}
                    isTempalteEditable={editable}
                    setEditable={setEditable}
                    selectedBotName={selectedBotName}
                    setOperationStatus={setOperationStatus}
                    isSubmitForApproval={isSubmitForApproval}
                    setIsSubmitForApproval={setIsSubmitForApproval}
                />
            ) : (
                <ListTemplates
                    searchParams={searchParams}
                    setSearchParams={setSearchParams}
                    handleViewDetailsChange={handleTemplateChange}
                    selectedBotName={selectedBotName}
                    setSelectedBotName={setSelectedBotName}
                />
            )}
            {operationStatus.success && (
                <SuccessMessageComponent message={operationStatus.message} handleClose={handleCloseSuccessMessage} show={operationStatus.success} />
            )}
        </Grid>
    );
}

export default ManageTemplates;
